module.exports = __webpack_public_path__ + "media/application/images/partners/kts-814ffa39dfdda2c0e0fafd383525dcabb2c1643ad1764b99641f2b9d2d892dbe.png";